import { getConfigName } from "@helpers/funciones";
import CotizadorAvanzaSolido from "./producto/credito_simple/avanza_solido/CotizadorAvanzaSolido";
import CotizadorFinbra from "./producto/credito_simple/finbra/CotizadorFinbra";
import CotizadorNowPorts from "./producto/credito_simple/nowports/CotizadorNowPorts";
import CotizadorKapitalFlex from "./producto/credito_simple/kapital_flex/CotizadorKapitalFlex";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { signOut } from "aws-amplify/auth";
import CotizadorProvidencia from "./producto/credito_simple/providencia/CotizadorProvidencia";
import CotizadorKalapata from "./producto/credito_simple/kalapata/Cotizador";

const domainMap: Record<string, React.FC> = {
  finbra: CotizadorFinbra,
  now_ports: CotizadorNowPorts,
  avanza_solido: CotizadorAvanzaSolido,
  kapital_flex: CotizadorKapitalFlex,
  providencia: CotizadorProvidencia,
  kalapata: CotizadorKalapata,
  sfi: CotizadorKalapata,
  afirme: CotizadorKalapata,
  santander: CotizadorKalapata,
  bbva: CotizadorKalapata,
};

export const Cotizadores = () => {
  const configName = getConfigName(window.location.href);
  const Component = domainMap[configName];

  useEffect(() => {
    const logout = async () => {
      localStorage.clear();
      await signOut();
    };

    logout();
  }, []);

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};
